module.exports = __webpack_public_path__ + "static/media/banner-logo-white.094ba476.svg";